// React
import { ReactElement } from 'react';
// Utils
import { getColorStyle } from '@utmb/utils/colors';
import { v4 as uuidv4 } from 'uuid';
// Design System
import { Font } from '@utmb/design-system/text/font';
import { Row } from '@utmb/design-system/box/Box';
// Styles
import styles from './stats.module.scss';
// Interfaces
import { ColorTypesEnum } from '@utmb/types/colors';
import { SliceRaceStatsView } from '@utmb/types/index';
import { StatView } from '@utmb/types/index';
import { useTranslation } from 'next-i18next';
import { KeyFigure } from '@utmb/features/key-figures/KeyFigure';

export const StatsPick = (props: SliceRaceStatsView): ReactElement | null => {
    const { stats } = props;

    if (!stats || !stats.length) return null;

    const pageHeaderStats = [styles.picks, 'utmb_container_mob_pad'].filter(Boolean).join(' ');

    return (
        <Row className={pageHeaderStats}>
            {stats?.map((item: StatView) => {
                return <Pick {...item} key={`${item.name}_${uuidv4()}`} />;
            })}
        </Row>
    );
};

const Pick = (props: StatView): ReactElement => {
    const { name } = props;
    const { t } = useTranslation();

    return (
        <div className={styles.stat}>
            <Font.OxaniumBold mobile="16" desktop="18" style={{ color: ColorTypesEnum.WHITE }}>
                {t(`races.keyfigures.${name}`)}
            </Font.OxaniumBold>
            <Font.OxaniumBold mobile="18" desktop="24" style={{ letterSpacing: '-0.3px' }}>
                <KeyFigure {...props} />
            </Font.OxaniumBold>
        </div>
    );
};

interface StatsBarProps extends SliceRaceStatsView {
    bgcolor?: string;
    color?: string;
}

export const StatsBar = (props: StatsBarProps): ReactElement | null => {
    const { bgcolor = ColorTypesEnum.RACE_PRIMARY, color = ColorTypesEnum.WHITE, stats } = props;
    if (!stats || !stats.length) return null;

    return (
        <Row className={styles.stats_bar_wrapper} style={{ backgroundColor: getColorStyle(bgcolor), color: getColorStyle(color) }}>
            <div className={`${styles.bar} container`}>
                {stats?.map((item: StatView) => (
                    <Stat {...item} key={uuidv4()} />
                ))}
            </div>
        </Row>
    );
};

const Stat = (props: StatView): ReactElement => {
    const { name } = props;
    const { t } = useTranslation();

    return (
        <div className={styles.stat}>
            <Font.OxaniumRegular mobile="12" desktop="12" className={styles.label_content}>
                {t(`races.keyfigures.${name}`)}
            </Font.OxaniumRegular>
            <Font.OxaniumBold mobile="18" desktop="18" className={styles.value_content}>
                <KeyFigure {...props} />
            </Font.OxaniumBold>
        </div>
    );
};

export const StatsRacePick = (props: SliceRaceStatsView): ReactElement => {
    const { stats } = props;

    return (
        <div className={`${styles.racepick_container} container`}>
            {stats?.map((item: StatView) => {
                return <RacePick {...item} key={uuidv4()} />;
            })}
        </div>
    );
};

export const RacePick = (props: StatView): ReactElement => {
    const { name } = props;
    const { t } = useTranslation();
    return (
        <div className={styles.pick_wrapper}>
            <div className={styles.pick_item}>
                <Font.OxaniumBold mobile="16" desktop="18" style={{ color: ColorTypesEnum.WHITE }}>
                    {t(`races.keyfigures.${name}`)}
                </Font.OxaniumBold>
                <Font.OxaniumBold mobile="18" desktop="24" style={{ letterSpacing: '-0.3px' }}>
                    <KeyFigure {...props} />
                </Font.OxaniumBold>
            </div>
        </div>
    );
};
